import { ActivatedRoute } from '@angular/router';
import { DUAL_REAR_TIRES_CATEGORY_NAME, InspectionService } from './inspection.service';
import { AuthenticationStateService } from '@quorum/authentication/services';
import { take, filter, map } from 'rxjs/operators';
import { AuthenticatedUser } from 'libs/authentication/src/lib/+state/authentication.interfaces';
import { MediaObserver } from '@angular/flex-layout';
import { BreakpointObserver } from '@angular/cdk/layout';
import {
  GmVehicleInspectionReportTask,
  OemRooftopLink,
  VehicleBrakeMeasurement,
  VehicleInspectionReportCategory,
  VehicleInspectionReportTireSection,
} from '@quorum/models/xs-resource';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { ApiService } from '@quorum/api';
import { SystemControlStateService } from '@quorum/xsr-system-control/services';
export class VcrBaseComponent {
  oemrtId: any;
  workOrderId: any;
  quoteId: any;
  reportType: any;
  emailSending: any = false;
  currentUserId: any;
  report: any = {
    header: { expressFlag: true },
  };
  logo: any;
  displaySaviIconFlags$: Observable<{ gmOem: boolean; vehicleDiagnosticsEnabled: boolean }>;

  constructor(
    public inspectionService: InspectionService,
    public activatedRoute: ActivatedRoute,
    public authenticationStateService: AuthenticationStateService,
    public mediaService: MediaObserver,
    public breakpointObserver: BreakpointObserver,
    public systemControlStateService: SystemControlStateService,
    public apiService: ApiService
  ) {}

  Init() {
    var self = this;
    self.inspectionService.preInspectionDataGathered$.subscribe((data) => {
      console.log('pre inspection data');
      console.log(data);
      self.workOrderId = data.workOrderId;
      self.quoteId = data.quoteId;
      //self.getReportData(self.workOrderId, self.quoteId);
      self.authenticationStateService
        .selectAuthenticatedUser()
        .pipe(take(1))
        .subscribe((user: AuthenticatedUser) => {
          self.currentUserId = user.user.xselleratorEmployeeId;
        });

      self.authenticationStateService
        .selectAuthenticatedEmployee()
        .pipe(
          filter((emp) => emp != null),
          take(1)
        )
        .subscribe((employee) => {
          console.log('got employee');
          self.oemrtId = employee.rooftopId;

          // self.inspectionService
          //   .getSystemControlValue(self.oemrtId, 'CL_AZURE_DEALERSHIP_LOGO_NAME')
          //   .then(function (response) {
          //     console.log(response);
          //     self.logo = response;
          //   });

          this.displaySaviIconFlags$ = combineLatest([
            this.apiService
              .get(`/v/1/system/oem-rooftop-links/${employee.rooftopId}`)
              .pipe(map((oemRooftopLink: OemRooftopLink) => oemRooftopLink.associateId)),
            this.systemControlStateService.getSystemControlValues(
              ['CL_OEM_VEHICLE_DIAGNOSTIC_DATA_ENABLED'],
              employee.rooftopId
            ),
          ]).pipe(
            map(([oem, vehicleDiagnosticsEnabled]) => {
              return {
                gmOem: oem === 'GM',
                vehicleDiagnosticsEnabled:
                  vehicleDiagnosticsEnabled.CL_OEM_VEHICLE_DIAGNOSTIC_DATA_ENABLED?.value === '1',
              };
            })
          );
        });
    });
    //self.reportType = self.inspectionService.inspection.reportType;
  }

  isExcludedTask(brakeMeasurementTasks: any[], task: any): boolean {
    return brakeMeasurementTasks?.some((excludedTask) => excludedTask.TaskName === task?.TaskName);
  }

  getReportData(workOrderId: any, quoteId: any) {
    var self = this;
    self.inspectionService.getVcrReportData(workOrderId, quoteId).then(function (report) {
      self.report = report;
    });
  }

  getPassedTasksCount(tasks: any) {
    var passedCount = 0;
    for (var i = 0; i < tasks.length; i++) {
      if (tasks[i].Color === 'Green') {
        passedCount++;
      }
    }
    return passedCount;
  }

  getPassedTasksCountMobile(CategoryId: any) {
    var self = this;
    var passedCount = 0;
    for (var i = 0; i < self.report.tasks.length; i++) {
      if (CategoryId === self.report.tasks[i].CategoryId && self.report.tasks[i].Color === 'Green') {
        passedCount++;
      }
    }
    return passedCount;
  }

  getQuoteTotal(quoteLines: any) {
    var quoteTotal = 0;
    if (quoteLines) {
      for (var i = 0; i < quoteLines.length; i++) {
        quoteTotal += quoteLines[i].CaseTotal;
      }
      return quoteTotal;
    }
  }

  getFlexBasis() {
    var self = this;

    if (self.breakpointObserver.isMatched('Handset')) {
      return {
        'flex-basis': '100%',
      };
    } else if (self.breakpointObserver.isMatched('Handset')) {
      return {
        'flex-basis': '50%',
      };
    } else if (self.breakpointObserver.isMatched('Tablet')) {
      return {
        'flex-basis': '25%',
      };
    } else if (self.breakpointObserver.isMatched('Web')) {
      return {
        'flex-basis': '20%',
      };
    }
  }

  getStatus(color: any) {
    if (color === 'Green') {
      return 'Passed';
    } else if (color === 'Yellow') {
      return 'Warning';
    } else if (color === 'Red') {
      return 'Failed';
    }
  }

  getFluidFilled(fluidFilled: any) {
    if (fluidFilled === true) {
      return '(Fluid Filled)';
    } else {
      return '';
    }
  }

  tireOtherFilter(task: any) {
    if (task.red === true) {
      return task;
    }
  }

  getAbsoluteHeight(element: any) {
    console.log('FF');
    var styles = window.getComputedStyle(element);
    var margin = parseFloat(styles['marginTop']) + parseFloat(styles['marginBottom']);

    return Math.ceil(element.offsetHeight + margin);
  }

  //Tire-measurement rows from optional categories (e.g. Dual Rear Tires) grouped by
  //category, assessed rows only. Rows from procs that predate the categoryName column
  //are skipped so pre-update databases render the report exactly as before.
  getOptionalTireSections(
    tires: readonly VehicleInspectionReportTireSection[]
  ): { categoryName: string; tires: VehicleInspectionReportTireSection[] }[] {
    const sections: { categoryName: string; tires: VehicleInspectionReportTireSection[] }[] = [];
    (tires || []).forEach((tire) => {
      if (!tire || !tire.categoryName || tire.staticKey === 'TIRES') {
        return;
      }
      if (!tire.green && !tire.yellow && !tire.red) {
        return;
      }
      let section = sections.find((s) => s.categoryName === tire.categoryName);
      if (!section) {
        section = { categoryName: tire.categoryName, tires: [] };
        sections.push(section);
      }
      section.tires.push(tire);
    });
    return sections;
  }

  //Same idea for the categories-keyed report payload (GEN/GM branch): categories whose
  //task arrays contain assessed tire-measurement tasks. Requires displayTireTread from
  //pGetGmVehicleInspectionReportTasks — absent (older proc) means no sections.
  getOptionalTireCategories(categories: {
    [key: string]: VehicleInspectionReportCategory;
  }): { categoryName: string; tasks: GmVehicleInspectionReportTask[] }[] {
    const sections: { categoryName: string; tasks: GmVehicleInspectionReportTask[] }[] = [];
    if (!categories) {
      return sections;
    }
    Object.keys(categories).forEach((key) => {
      const category = categories[key];
      if (!category || !Array.isArray(category.tasks)) {
        return;
      }
      const tireTasks = (category.tasks as GmVehicleInspectionReportTask[]).filter(
        (task) => task.displayTireTread && ['Green', 'Yellow', 'Red'].includes(task.color)
      );
      if (tireTasks.length > 0) {
        sections.push({
          categoryName: category.name || key,
          tasks: [...tireTasks].sort((a, b) => (Number(a.sequence) || 0) - (Number(b.sequence) || 0)),
        });
      }
    });
    return sections;
  }

  //Whether the report carries any optional tire section at all. The one-page print prints
  //those below its fixed tire grid, which is what pushes Brakes and the visible/functional
  //list onto a second page, so its layout tightens only when this is true.
  hasOptionalTireSections(categories: { [key: string]: VehicleInspectionReportCategory }): boolean {
    return this.getOptionalTireCategories(categories).length > 0;
  }

  trackByCategoryName(index: number, section: { categoryName: string }): string {
    return section.categoryName;
  }

  //An assessed Dual Rear Tires section stands in for the standard card's two rear positions,
  //so without this the report prints empty LR/RR rows beside the dually rows replacing them.
  hasDualRearTireSection(tires: readonly VehicleInspectionReportTireSection[]): boolean {
    return this.getOptionalTireSections(tires).some(
      (section) => section.categoryName === DUAL_REAR_TIRES_CATEGORY_NAME
    );
  }

  //Same test against the categories-keyed report payload used by the GEN one-page print.
  //getOptionalTireCategories falls back to the payload key, so 'DualRearTires' must match too.
  hasDualRearTireCategory(categories: { [key: string]: VehicleInspectionReportCategory }): boolean {
    return this.getOptionalTireCategories(categories).some((section) =>
      this.isDualRearTiresName(section.categoryName)
    );
  }

  private isDualRearTiresName(categoryName: string): boolean {
    const alphanumericsOnly = (value: string): string => (value || '').replace(/[^a-z0-9]/gi, '').toLowerCase();
    return alphanumericsOnly(categoryName) === alphanumericsOnly(DUAL_REAR_TIRES_CATEGORY_NAME);
  }

  getBrakeMeasurement(task: any, brakeMeasurements: VehicleBrakeMeasurement[], inspection: any) {
    const brakeMeasurementId = inspection.categories
      .find((category: any) => category.categoryId === task.CategoryId)
      ?.tasks?.find((categoryTask: any) => categoryTask.taskName === task.TaskName)?.brakeMeasurementId;

    return brakeMeasurementId
      ? ' - ' +
          brakeMeasurements.find(
            (breakMeasurement: VehicleBrakeMeasurement) => breakMeasurement.id === brakeMeasurementId
          )?.measurement
      : '';
  }
}
